import React from 'react';
import { Typography } from '@mui/material';

const RequiredMark = () => (
  <>
    &nbsp;
    <Typography component="span" variant="body3" color="error">
      *
    </Typography>
  </>
);

export default RequiredMark;
